import React, { useContext } from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import { LanguageContext } from "./LanguageContext";

const PimsBranding = ({ compact = false }) => {
    const { translations } = useContext(LanguageContext);

    return (
        <Stack spacing={1} alignItems="center" sx={{ p: compact ? 1.5 : 2 }}>
            <Link
                href="https://peo.ba"
                target="_blank"
                rel="noopener"
                sx={(theme) => ({
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    p: 1.5,
                    borderRadius: 2,
                    bgcolor:
                        theme.palette.mode === "dark"
                            ? "rgba(255,255,255,0.04)"
                            : "rgba(15,23,42,0.04)",
                    transition: "all 0.2s ease",
                    "&:hover": {
                        bgcolor:
                            theme.palette.mode === "dark"
                                ? "rgba(255,255,255,0.07)"
                                : "rgba(15,23,42,0.07)",
                    },
                })}
            >
                <Box
                    component="img"
                    src="/pims_logo.jpg"
                    alt="PIMS Elektro Oprema"
                    sx={{ maxWidth: "85%", maxHeight: 48, height: "auto", borderRadius: 0.5 }}
                />
            </Link>
            <Typography
                variant="caption"
                sx={{ color: "text.secondary", textAlign: "center", lineHeight: 1.4 }}
            >
                {translations.pimsVersion || "PIMS Elektro Oprema d.o.o. — Edition v1.0"}
            </Typography>
        </Stack>
    );
};

export default PimsBranding;